import React, { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

const User = () => {
  // const {userid}=useParams();
  const [searchParam, setSearchParam] = useSearchParams();
  const [name, setName] = useState();
  const [age, setAge] = useState();
  const handleSubmit = (e) => {
    e.preventDefault();
    setSearchParam({ name: name, age:age });
  }
  return (
    <div>
      <h4>User (value pass using by URL)</h4>
      <form onSubmit={handleSubmit}>
        <input type='text' name='name' value={name} onChange={(e) => { setName(e.target.value);  }} />
        <input type='text' name='age' value={age} onChange={(e) => { setAge(e.target.value); }} />
        <button type="submit">Pass Value</button>
      </form>

      <p>{searchParam.get("id")}</p>
      <p>{searchParam.get("age")}</p>
      <p>{searchParam.get("name")}</p>
    </div>
  )
}

export default User

// url : http://localhost:3000/user?id=101&age=35&name=Motaleb
// Output:
// Id : 101
// age : 35
//  Name : Motaleb